<div class="py-2 pt-0">
  <h3 class="font-thin border-b border-gray-300 mb-2 p-1">{{title}}</h3>
</div>

<app-material-park-data-table-1 [index]="1"
                                [store]="store"
                                (initialized)="subReportElementInitialized($event)"></app-material-park-data-table-1>

<app-material-park-data-table-2 [index]="2"
                                [store]="store"
                                (initialized)="subReportElementInitialized($event)"></app-material-park-data-table-2>

<app-material-park-data-table-3 [index]="3"
                                [store]="store"
                                (initialized)="subReportElementInitialized($event)"></app-material-park-data-table-3>

<app-material-park-data-chart-1 [index]="4"
                                [store]="store"
                                (initialized)="subReportElementInitialized($event)"></app-material-park-data-chart-1>

<app-material-park-data-chart-2 [index]="5"
                                [store]="store"
                                (initialized)="subReportElementInitialized($event)"></app-material-park-data-chart-2>
